import React from "react";

const NoDataState = () => (
  <div className="flex flex-col items-center justify-center py-[150px] h-full">
    <div className="text-center mb-6">
      <div className="text-4xl mb-2">📊</div>
      <h3 className="text-xl font-semibold text-white mb-2">
         Data is currently unavailable
      </h3>
    </div>
  </div>
);

export default NoDataState;